"use client";

import AutoInfiniteCarousel from "@components/widgets/auto-infinite-carousel";

import { OFFERINGS_PATH } from "@constants/routes";

import flagUsa from "@assets/images/catalog-slider/flag-usa.svg";
import flagIndia from "@assets/images/catalog-slider/flag-india.svg";
import flagUk from "@assets/images/catalog-slider/flag-uk.svg";
import flagIreland from "@assets/images/catalog-slider/flag-ireland.svg";
import flagPhilippines from "@assets/images/catalog-slider/flag-philippines.svg";
import flagSingapore from "@assets/images/catalog-slider/flag-singapore.svg";
import flagAustralia from "@assets/images/catalog-slider/flag-australia.svg";
import flagMexico from "@assets/images/catalog-slider/flag-mexico.svg";
import flagCanada from "@assets/images/catalog-slider/flag-canada.svg";
import flagJapan from "@assets/images/catalog-slider/flag-japan.svg";
import flagChina from "@assets/images/catalog-slider/flag-china.svg";
import flagAustria from "@assets/images/catalog-slider/flag-austria.svg";
import flagNewZealand from "@assets/images/catalog-slider/flag-newzealand.svg";
import flagThailand from "@assets/images/catalog-slider/flag-thailand.svg";
import flagFrance from "@assets/images/catalog-slider/flag-france.svg";

import productUsa from "@assets/images/catalog-slider/product-usa.png";
import productIndia from "@assets/images/catalog-slider/product-india.png";
import productUk from "@assets/images/catalog-slider/product-uk.png";
import productIreland from "@assets/images/catalog-slider/product-ireland.png";
import productPhilippines from "@assets/images/catalog-slider/product-philippines.png";
import productSingapore from "@assets/images/catalog-slider/product-singapore.png";
import productAustralia from "@assets/images/catalog-slider/product-australia.png";
import productMexico from "@assets/images/catalog-slider/product-mexico.png";
import productCanada from "@assets/images/catalog-slider/product-canada.png";
import productJapan from "@assets/images/catalog-slider/product-japan.png";
import productChina from "@assets/images/catalog-slider/product-china.png";
import productAustria from "@assets/images/catalog-slider/product-austria.png";
import productNewZealand from "@assets/images/catalog-slider/product-newzealand.png";
import productThailand from "@assets/images/catalog-slider/product-thailand.png";
import productFrance from "@assets/images/catalog-slider/product-france.png";
import worldwideBg from "@assets/images/catalog/worldwide-bg.png";

export const COUNTRY_IMAGES = [
  { titleImg: flagUsa, tileImg: productUsa, title: "USA" },
  { titleImg: flagIndia, tileImg: productIndia, title: "INDIA" },
  { titleImg: flagUk, tileImg: productUk, title: "UNITED KINGDOM" },
  { titleImg: flagIreland, tileImg: productIreland, title: "IRELAND" },
  { titleImg: flagPhilippines, tileImg: productPhilippines, title: "PHILIPPINES" },
  { titleImg: flagSingapore, tileImg: productSingapore, title: "SINGAPORE" },
  { titleImg: flagAustralia, tileImg: productAustralia, title: "AUSTRALIA" },
  { titleImg: flagMexico, tileImg: productMexico, title: "MEXICO" },
  { titleImg: flagCanada, tileImg: productCanada, title: "CANADA" },
  { titleImg: flagJapan, tileImg: productJapan, title: "JAPAN" },
  { titleImg: flagChina, tileImg: productChina, title: "CHINA" },
  { titleImg: flagAustria, tileImg: productAustria, title: "AUSTRIA" },
  { titleImg: flagNewZealand, tileImg: productNewZealand, title: "NEW ZEALAND" },
  { titleImg: flagThailand, tileImg: productThailand, title: "THAILAND" },
  { titleImg: flagFrance, tileImg: productFrance, title: "FRANCE" },
];

export const COUNTRY_CAROUSEL_CONTENT = {
  buttonText: "GET STARTED",
  buttonLink: OFFERINGS_PATH,
  cardDetails: COUNTRY_IMAGES,
  bgImg: worldwideBg,
};

const CountryInfiniteCarousel = (props) => (
  <AutoInfiniteCarousel content={COUNTRY_CAROUSEL_CONTENT} {...props} />
);

export default CountryInfiniteCarousel;
